import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.moveToEditor()
    }
  }

  moveToEditor() {
    const editor = document.querySelector('[data-controller="tiptap"]')
    if (editor) {
      const editorController = this.application.getControllerForElementAndIdentifier(editor, 'tiptap')
      editorController.editor.chain().focus().run()
    }
  }
} 